export default {
  fi: {
    VehicleCreateScene: {
      addVehicle: 'Lisää ajoneuvo',
      notSavedCheckFields: 'Ajoneuvoa ei tallennettu. Tarkista kentät.',
    },
  },
};
